function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_4_",
  fill: "#ffffff",
  d: "M350,157.3c-10.2-12.1-25.1-19.5-41-19.5c-31.7-0.9-56.8,26.1-56.8,58.6c0,4.7,0.9,9.3,1.9,14   c-46.5-2.8-88.4-27.9-116.4-64.2c-4.7,8.4-7.4,19.5-7.4,29.8c0,21.4,10.2,39.1,25.1,50.3c-9.3,0-17.7-2.8-26.1-7.4v0.9   c0,28.9,19.5,54,45.6,59.6c-4.7,0.9-9.3,1.9-14.9,1.9c-3.7,0-7.4,0-10.2-0.9c7.4,24.2,27.9,41.9,53.1,41.9   c-19.5,15.8-43.8,26.1-69.8,25.1c-4.7,0-9.3,0-13-0.9c25.1,16.8,54.9,27,86.6,27c104.3,0,161-90.3,161-169.4c0-2.8,0-5.6,0-7.4   c11.2-8.4,20.5-18.6,27.9-30.7c-10.2,4.7-21.4,7.4-32.6,9.3c12.1-7.4,20.5-18.6,25.1-32.6C375.2,149.9,363.1,154.5,350,157.3z"
}));

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.86723417.svg";
export { ForwardRef as ReactComponent };